// extracted by mini-css-extract-plugin
export var alignCenter = "_9s-d";
export var bannerShown = "_9s-6";
export var buttonContent = "_9s-0";
export var cardList = "_9s-1";
export var centerContent = "_9s-2";
export var chevron = "_9s-3";
export var closePanelButton = "_9s-k";
export var conversationContextContainer = "_9s-l";
export var conversationDetailContainer = "_9s-4";
export var detailWrapper = "_9s-7";
export var dropdownButton = "_9s-e";
export var dropdownTitle = "_9s-9";
export var fullHeight = "_9s-5";
export var hidden = "_9s-a";
export var icon = "_9s-b";
export var mergeSuggestionWrapper = "_9s-m";
export var panel = "_9s-i";
export var portalButtonsWrapper = "_9s-c";
export var right = "_9s-j";
export var tableSummaryContainer = "_9s-8";
export var tableSummaryHeader = "_9s-g";
export var threeDotsButton = "_9s-f";
export var wide = "_9s-h";